import React from 'react';
import OverviewAccountSkeleton from '../skeletons/OverviewAccountSkeleton';

function AccountsSection({ accountLoading, currencyAccount, balance }) {
    return (
        <>
        {!accountLoading ? (
             <div className='col-md-5'>
                <div className="accountDetail">
                    <div className='accountType'>{currencyAccount}</div>
                    <div className='accountAmount'>{balance}</div>
                </div>
            </div>
         ) : (
            <OverviewAccountSkeleton />
         )}
        </>
        
           
    );
}

export default AccountsSection;
